import { Mic, ScanBarcode } from "lucide-react";

/**
 * Segmented control that lets the cashier switch between:
 *   • "voice"   → Chalán listens (mic + wake word). Hardware scanner OFF.
 *   • "scanner" → Bluetooth/USB HID scanner active. Mic OFF.
 *
 * Preference is persisted in localStorage under `chalann_capture_mode`.
 * The parent owns the state — this is a pure presentational toggle.
 */
export const CAPTURE_MODE_KEY = "chalann_capture_mode";
export const CAPTURE_MODE_VOICE = "voice";
export const CAPTURE_MODE_SCANNER = "scanner";

export function readCaptureMode() {
  if (typeof window === "undefined") return CAPTURE_MODE_VOICE;
  const v = localStorage.getItem(CAPTURE_MODE_KEY);
  return v === CAPTURE_MODE_SCANNER ? CAPTURE_MODE_SCANNER : CAPTURE_MODE_VOICE;
}

export function persistCaptureMode(mode) {
  if (typeof window === "undefined") return;
  localStorage.setItem(CAPTURE_MODE_KEY, mode);
}

export default function CaptureModeToggle({ value, onChange }) {
  const isVoice = value === CAPTURE_MODE_VOICE;
  const btn = "flex items-center gap-1.5 px-3 py-1.5 rounded-full font-mono text-[10px] tracking-widest uppercase transition-colors";
  return (
    <div className="flex flex-col items-end gap-1" data-testid="capture-mode-toggle">
      <span className="font-mono text-[9px] tracking-widest text-white/40 uppercase">
        Método de captura
      </span>
      <div
        role="tablist"
        aria-label="Método de captura"
        className="inline-flex items-center gap-1 rounded-full border border-white/10 bg-black/60 backdrop-blur-md p-1"
      >
        <button
          role="tab"
          aria-selected={isVoice}
          onClick={() => onChange(CAPTURE_MODE_VOICE)}
          className={`${btn} ${isVoice ? "bg-[#ccff00] text-black" : "text-white/60 hover:text-white"}`}
          data-testid="capture-mode-voice"
          title="Comandos por voz"
        >
          <Mic size={12} />
          <span>Voz</span>
        </button>
        <button
          role="tab"
          aria-selected={!isVoice}
          onClick={() => onChange(CAPTURE_MODE_SCANNER)}
          className={`${btn} ${!isVoice ? "bg-[#ff5a00] text-black" : "text-white/60 hover:text-white"}`}
          data-testid="capture-mode-scanner"
          title="Escáner físico / pistola HID"
        >
          <ScanBarcode size={12} />
          <span>Escáner</span>
        </button>
      </div>
    </div>
  );
}
